import { useContext, useEffect, useState } from 'react';
import { Header, Stack } from 'buzz_lib_ui';
import { AppNavContext } from 'buzz_lib_contexts';
import { useAuthContext } from 'buzz_lib_auth';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const Home = () => {
  const navLinkGroup = useContext(AppNavContext);
  const authContext = useAuthContext();
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setMenuOpen(true);
    }, 700);
    return () => clearTimeout(timer);
  }, []);
  return /*#__PURE__*/_jsx(Stack, {
    children: /*#__PURE__*/_jsxs(Header, {
      user: authContext.user,
      openMenu: menuOpen,
      navLinkGroup: navLinkGroup !== null && navLinkGroup !== void 0 ? navLinkGroup : undefined,
      children: ["Buzz ", process.env.REACT_APP_BUZZENV !== 'prod' ? process.env.REACT_APP_BUZZENV : '']
    })
  });
};
export default Home;